import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'yes_does_facility_recruiting_agency_ever_request_that'

export const dataPointDefinition = {
  retracedId: 'yes_does_facility_recruiting_agency_ever_request_that',
  name: 'If yes, does the facility (or recruiting agency) ever request that foreign migrants sign a new contract once they are in',
  description:
    'The intent of this question is to understand whether foreign migrants are requested to sign a NEW contract, after arrival in the host country (in which the facility is located).',
  meta: {
    slcpMeta: {
      key: 'ep-4--1',
      number: 'RH-EMP-22',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ep-4--1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27010,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
